import { Pipe, PipeTransform } from '@angular/core';

import { getMarkerColorClass } from '../constants/constants';

@Pipe({ name: 'getMarkerColorClass' })
export class GetMarkerColorClassPipe implements PipeTransform {
  transform(
    parameter: string,
    value: number,
    isPigeonCustomer: boolean,
    smwServiceGreenTableDesign: boolean
  ) {
    return getMarkerColorClass(
      parameter,
      value,
      isPigeonCustomer,
      smwServiceGreenTableDesign
    );
  }
}
